import { render, staticRenderFns } from "./Subpoenas.vue?vue&type=template&id=8fe4091c&"
import script from "./Subpoenas.vue?vue&type=script&lang=js&"
export * from "./Subpoenas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports